import { SET_AUTH_TOKEN, SET_IP_ADDRESS, SET_LOGOUT } from '../utils/constants'

export const setAuthToken = (payload) => ({ type: SET_AUTH_TOKEN, payload })
export const setIpAddress = (payload) => ({ type: SET_IP_ADDRESS, payload })
export const setLogout = (payload) => ({ type: SET_LOGOUT, payload })
